import { AppCard, AppCardBody, AppText, kindredFontFamilies } from "../../ui-foundation";
import {
  DocumentList,
  DocumentPageScaffold,
  DocumentSection,
} from "@/components/DocumentScaffold";
import {
  KINDRED_BREACH_RESPONSE_PROCESS_BULLETS,
  KINDRED_BREACH_REPORTING_COPY,
  KINDRED_COMPLAINT_HANDLING_BULLETS,
  KINDRED_COUNTRY_ANNEX_COMPLAINTS_BULLETS,
  KINDRED_DATA_PROTECTION_ESCALATION_BULLETS,
  KINDRED_DATA_PROTECTION_ESCALATION_LEAD,
  KINDRED_FEEDBACK_CHANNEL_PATH,
  KINDRED_FORMAL_REQUEST_PROCESS_BULLETS,
  KINDRED_MODERATION_REVIEW_BULLETS,
  KINDRED_SUPPORT_COUNTRY_COVERAGE_COPY,
  KINDRED_SUPPORT_EMAIL,
  STEADY_HOUSE_COMPANY_NUMBER,
  STEADY_HOUSE_LEGAL_NAME,
  STEADY_HOUSE_REGISTERED_OFFICE,
  STEADY_HOUSE_SUPPORT_URL,
} from "../../shared/support";

const ContactComplaints = () => {
  return (
    <DocumentPageScaffold
      title="Contact & complaints"
      updatedLabel="Last updated: April 2026"
      fallbackPath="/"
    >
      <DocumentSection title="1. Who to contact">
        <AppText>
          Kindred Community is operated by {STEADY_HOUSE_LEGAL_NAME} (company {STEADY_HOUSE_COMPANY_NUMBER}),
          registered in England and Wales. Registered office: {STEADY_HOUSE_REGISTERED_OFFICE}.
        </AppText>
      </DocumentSection>

      <DocumentSection title="2. General support">
        <AppText>
          For account help, access problems, broken features, moderation follow-up, privacy questions,
          document corrections, or support with any Kindred document, use the{" "}
          <a
            href={STEADY_HOUSE_SUPPORT_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="kindred-inline-link"
          >
            Steady House support page
          </a>{" "}
          or email{" "}
          <a href={`mailto:${KINDRED_SUPPORT_EMAIL}`} className="kindred-inline-link">
            {KINDRED_SUPPORT_EMAIL}
          </a>
          .
        </AppText>
      </DocumentSection>

      <DocumentSection title="3. Safety and safeguarding reports">
        <DocumentList
          items={[
            "Use the in-app reporting tools where they are available",
            "Use block tools first if you need immediate distance from another member",
            "Email support straight away for urgent safeguarding concerns or child-safety issues",
            "Contact emergency services first if someone is in immediate danger",
          ]}
        />
      </DocumentSection>

      <DocumentSection title="4. How Kindred handles complaints and formal requests">
        <DocumentList items={[...KINDRED_FORMAL_REQUEST_PROCESS_BULLETS, ...KINDRED_COMPLAINT_HANDLING_BULLETS]} />
      </DocumentSection>

      <DocumentSection title="5. Moderation review and account-action review">
        <DocumentList items={[...KINDRED_MODERATION_REVIEW_BULLETS]} />
      </DocumentSection>

      <DocumentSection title="6. Privacy, data rights, and breach reports">
        <AppText>
          Privacy questions, data-rights requests, and formal complaints about how personal data is handled
          should go through the support route above so they can be logged and reviewed properly.
        </AppText>
        <AppText>{KINDRED_BREACH_REPORTING_COPY}</AppText>
        <DocumentList items={[...KINDRED_BREACH_RESPONSE_PROCESS_BULLETS]} />
        <AppText>{KINDRED_DATA_PROTECTION_ESCALATION_LEAD}</AppText>
        <DocumentList items={[...KINDRED_DATA_PROTECTION_ESCALATION_BULLETS]} />
      </DocumentSection>

      <DocumentSection title="7. Product feedback and suggestions">
        <AppText>
          Signed-in members should use <strong>{KINDRED_FEEDBACK_CHANNEL_PATH}</strong> for product feedback,
          bug reports, ideas, and suggestions. That keeps product feedback separate from safety and complaints
          handling.
        </AppText>
      </DocumentSection>

      <DocumentSection title="8. Guidance corrections and country coverage">
        <AppText>
          If a support pack or information page looks unclear, outdated, or inaccurate, tell us through the
          same support route so we can review and correct it.
        </AppText>
        <AppText>{KINDRED_SUPPORT_COUNTRY_COVERAGE_COPY}</AppText>
      </DocumentSection>

      <DocumentSection title="9. Country Annex Contacts">
        <DocumentList items={[...KINDRED_COUNTRY_ANNEX_COMPLAINTS_BULLETS]} />
      </DocumentSection>

      <AppCard backgroundColor="$panelBackground">
        <AppCardBody alignItems="center">
          <AppText
            textAlign="center"
            fontFamily={kindredFontFamilies.sansBold}
            fontSize="$md"
            lineHeight="$md"
          >
            Support, safeguarding, privacy, breach reporting, and complaints should come to the Steady House
            support route. Product ideas belong in the Kindred feedback channel.
          </AppText>
        </AppCardBody>
      </AppCard>
    </DocumentPageScaffold>
  );
};

export default ContactComplaints;
